import http from './index'
import QS from 'qs'
const clientId = 'ydoMkThn35TQh6Pm'
// 企业员工登录
export const login = data => {
  data = QS.stringify({
    ...data,
    scene: 6, // 应用场景 1 web页面,2 android司机端,3 ios 司机端
    terminalType: 1  // 设备终端类型  1-web(桌面网页) 2-wap(app网页) 3-android 4-ios 5-微信小程序}
  })
  return http({
    url: '/zhongcheyun/user/login/3',
    method: 'POST',
    headers: { scope: 1 },
    data
  })
}
/**
 * 登录验证码
 * @param
 */
export const codeLogin = data => {

  data = QS.stringify({
    ...data,
    // app: app, // 应用标识 1 web页面,2 android司机端,3 ios 司机端
    scene: 6, // 应用场景 1 web页面,2 android司机端,3 ios 司机端
    terminalType: 1
  })
  return http({
    url: '/zhongcheyun/user/login/code/3',//'/zhongcheyun/login/3',
    method: 'POST',
    headers: { scope: 1 },
    data
  })
}
/**
 * 登录验证码
 * @param
 */
export const remarkCodeLogin = data => {

  data = QS.stringify({
    ...data,
    // app: app, // 应用标识 1 web页面,2 android司机端,3 ios 司机端
    scene: 9, // 应用场景 1 web页面,2 android司机端,3 ios 司机端
    terminalType: 1
  })
  return http({
    url: '/zhongcheyun/user/login/code/3',//'/zhongcheyun/login/3',
    method: 'POST',
    headers: { scope: 1 },
    data
  })
}
/**
 * 个人-登录
 * @param
 */
export const personalLogin = data => {
  data = QS.stringify({
    ...data,
    scene: 7, // 应用场景 1 web页面,2 android司机端,3 ios 司机端
    terminalType: 1
  })
  return http({
    url: '/ums/user/login/1',
    method: 'POST',
    headers: { scope: 1 },
    data
  })
}
/**
 * 个人-登录
 * @param
 */
export const personalCodeLogin = data => {

  data = QS.stringify({
    ...data,
    // app: app, // 应用标识 1 web页面,2 android司机端,3 ios 司机端
    clientId: 7 // 应用场景 1 web页面,2 android司机端,3 ios 司机端
  })
  return http({
    url: '/ums/user/login/code/1',//'/ums/login/1',
    method: 'POST',
    headers: { scope: 1 },
    data
  })
}
/**
* 获取登录验证码
* @param
*/
export function loginSmsCode(data) {
  data = { ...data }
  return http({
    url: '/ums/sms/code/3',
    method: 'GET',
    params: data,
    headers: { scope: 1 }
  })
}
/**
 * 获取注册验证码
 * @param
 */
export function regSmsCode(data) {
  data = { ...data }
  return http({
    url: '/ums/sms/code/1',
    method: 'GET',
    params: data,
    headers: { scope: 1 }
  })
}
/**
* 个人-注册
* @param
*/
export const personalRegUser = data => {
  data = QS.stringify({
    ...data,
    // app: app, // 应用标识 1 web页面,2 android司机端,3 ios 司机端
    clientId: clientId, // 应用场景 1 web页面,2 android司机端,3 ios 司机端
    terminalType: 1 // 设备终端类型  1-web(桌面网页) 2-wap(app网页) 3-android 4-ios 5-微信小程序
  })
  return http({
    url: '/ums/user/register/1',
    method: 'POST',
    headers: { scope: 1 },
    data
  })
}
/**
* 注册（管理）
* @param
*/
export const regUser = data => {
  data = QS.stringify({
    ...data,
    // app: app, // 应用标识 1 web页面,2 android司机端,3 ios 司机端
    clientId: clientId, // 应用场景 1 web页面,2 android司机端,3 ios 司机端
    terminalType: 1 // 设备终端类型  1-web(桌面网页) 2-wap(app网页) 3-android 4-ios 5-微信小程序
  })
  return http({
    url: '/ums/user/register/3',
    method: 'POST',
    headers: { scope: 1 },
    data
  })
}
// 获取企业列表
export const getUserEntList = query => {
  return http({
    url: '/ums/ent/list/simple',
    method: 'GET',
    params: query
  })
}
//获取用户信息
export const getInfo = query => {
  return http({
    url: '/ums/user',
    method: 'GET',
    params: query
  })
}
/**
 * 动态列表(所有人都可获取)
 * @param
 * 1公司介绍 2公司动态 3公司公告 4公司协议 5公司合同
 */
export const contentAllList = query => {
  return http({
    url: '/zhongcheyun/content/list/total',
    method: 'GET',
    params: query,
    headers: { scope: 1 }
  })
}
/**
 * 退出
 * @param
 */
export function logout(query) {
  return http({
    url: '/auth/user/logout/token',
    method: 'DELETE',
    params: { clientId: 6, scene: 6 }
  })
}
/**
 * 修改密码
 * @param
 */
export function pwdUpdate(data) {
  data = QS.stringify(data)
  return http({
    url: '/auth/password/1',
    method: 'PUT',
    params: {},
    data
  })
}
/**
 * 用户信息修改
 * @param
 */
export function updateUserInfo(data) {
  data = QS.stringify(data)
  return http({
    url: '/ums/user',
    method: 'PUT',
    params: {},
    data
  })
}
/**
 * 用户信息更换手机号
 * @param
 */
export function updateUserPhone(data) {
  data = Object.assign({}, data, {
    // app: app, // 应用标识 1 web页面,2 android司机端,3 ios 司机端
    clientId: clientId // 应用场景 1 web页面,2 android司机端,3 ios 司机端
  })
  data = QS.stringify(data)
  return http({
    url: '/ums/user/cellphone/3',
    method: 'PUT',
    params: {},
    data
  })
}
/**
 * 获取更换手机号
 * @param
 */
export function updateUserSmsCode(data) {
  data = Object.assign({}, data, {
    // app: app, // 应用标识 1 web页面,2 android司机端,3 ios 司机端
    // clientId: clientId // 应用场景 1 web页面,2 android司机端,3 ios 司机端
  })
  return http({
    url: '/ums/sms/code/4',
    method: 'GET',
    params: data
  })
}
/**
 * 忘记密码
 * @param
 */
export function forgetPwd(data) {
  data = Object.assign({}, data, {
    // app: app, // 应用标识 1 web页面,2 android司机端,3 ios 司机端
    // clientId: clientId // 应用场景 1 web页面,2 android司机端,3 ios 司机端
  })
  data = QS.stringify(data)
  return http({
    url: '/auth/password/0',
    method: 'PUT',
    params: {},
    data
  })
}
/**
* 忘记密码验证码
* @param
*/
export function forgetSendCode(data) {
  data = Object.assign({}, data, {
    // app: app, // 应用标识 1 web页面,2 android司机端,3 ios 司机端
    // clientId: clientId // 应用场景 1 web页面,2 android司机端,3 ios 司机端
  })
  return http({
    url: '/auth/sms/code/2',
    method: 'GET',
    params: data,
    headers: { scope: 1 }
  })
}
/**
 * 拼图验证码-获取
 */
export function captchaDetail(query) {
  return http({
    url: '/auth/captcha/2_0_5/3',
    method: 'GET',
    params: query,
    headers: { scope: 1 }
  })
}
/**
 * 获取省市区树
 * @param
 */
export function getAreaTree() {
  return http({
    url: '/zhongcheyun/area/tree',
    method: 'GET',
  })
}
/**
 * 钉钉中获取付款账单详情
 * @param
 */
export function getDingtalkChargebill(data) {
  return http({
    url: '/zhongcheyun/chargebill/dingtalk/wap',
    method: 'GET',
    params: data
  })
}
/**
 * 钉钉中获取发票账单详情
 * @param
 */
export function getDingtalkInvoice(data) {
  return http({
    url: '/zhongcheyun/invoicebill/dingtalk/wap',
    method: 'GET',
    params: data
  })
}
/**
 * 费用账单运单列表
 * @param
 */
export function getDingtalkOrderList1(data) {
  return http({
    url: '/zhongcheyun/chargebill/lo/list/dingtalk/wap',
    method: 'GET',
    params: data
  })
}
/**
 * 费用账单垫资运单列表
 * @param
 */
export function getDingtalkOrderList2(data) {
  return http({
    url: '/zhongcheyun/chargebill/lo/list/dingtalk/wap/credit',
    method: 'GET',
    params: data
  })
}
/**
 * 发票账单运单列表
 * @param
 */
export function getDingtalkOrderList3(data) {
  return http({
    url: '/zhongcheyun/invoicebill/lo/list/dingtalk/wap',
    method: 'GET',
    params: data
  })
}
/**
 * 动态详情
 * @param
 */
export function momentDetail(number) {
  return http({
    url: `/moment/moment/share/${number}`,
    method: 'GET',
    headers: { scope: 1 }
  })
}
/**
 * 获取微信签名
 * @param
 */
export function getWeixinConfig(data) {
  return http({
    url: `/auth/offiaccount/signature`,
    method: 'GET',
    params:data,
    headers: { scope: 1 }
  })
}
/**
 * 获取发票文件
 * @param
 */
export function getInvoviceFile(data) {
  return http({
    url: `/zhongcheyun/invoiceBill/file/list/${data.number}`,
    method: 'GET',
    params:data
  })
}



// WEBPACK FOOTER //
// ./src/api/admin.js